import type { Mode } from "../api/types";

/** The label a player would use: a trader on a `buy` row is buying, which is a
 *  WTB; one on a `sell` row is selling, which is a WTS. The pill says the
 *  player's word, not the column's name — and the mapping inverts, so read it
 *  from the row's meaning (a bid is MAX(price)) rather than from the mode's
 *  spelling.
 *
 *  The uppercase is a literal string, not a `text-transform`. components.css's
 *  pill rule says "no uppercase and no tracking" because tokens.css calls
 *  --tracking-title the only tracked style; a literal acronym adds no tracking
 *  and does not break that rule. Nothing to fix here. */
const LABEL: Record<Mode, string> = {
  buy: "WTB", sell: "WTS", craft: "craft", package: "package",
};

/** Mode is always a word as well as a colour, so buy and sell stay
 *  distinguishable in greyscale, in forced-colors mode, and to anyone whose
 *  colour vision does not separate the pair.
 *
 *  Since the rose/olive pair replaced the older red/blue one that promise is
 *  load-bearing rather than a courtesy: the pair's CVD separation is ΔE 11.3
 *  where the old one was 19.7 — still past the target of 8, but this word is
 *  what makes the smaller margin safe. Here the word is the primary encoding
 *  and the colour is the redundant one. Do not reduce this pill to a swatch.
 *
 *  Only buy and sell get a hue. `craft` and `package` fall through to the base
 *  pill's neutral ink deliberately: demand and supply are the one distinction
 *  the tables rest on, and a third and fourth colour would blur it. */
export function ModePill({ mode }: { mode: Mode }) {
  return <span className={`pill ${mode}`}>{LABEL[mode]}</span>;
}
